<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <div class="canvas-item">
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6">
              <nav>
                <div class="nav nav-tabs mb-2" id="nav-tab">
                  <a class="nav-item nav-link title active p-2" id="nav-home-tab" data-toggle="tab" href="#nav-home"
                    role="tab">
                    <h2> Risk Management</h2>
                  </a>
                  <a class="nav-item nav-link title p-2" id="nav-profile-tab" data-toggle="tab" href="#nav-profile"
                    role="tab">
                    <h2>Risk Managment Graph</h2>
                  </a>
                </div>
              </nav>
            </div>
            <div class="col-sm-6" style="display: flex; justify-content: flex-end; align-items: center;">
              <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                <button type="button" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#riskModel">
                  <span><i class="ri-pencil-line"></i></span>
                </button>
              </div>
              <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                <button type="button" data-bs-toggle="modal" data-bs-target="#deleteRiskModal"
                  (click)="deleteOpenModal()">
                  <span><i class="ri-delete-bin-5-line"></i></span>
                </button>
              </div>
              <button type="button" (click)="createOpenModal()" data-bs-toggle="modal" data-bs-target="#riskModel"
                class="btn btn-icon">
                <i class="ri-add-line"></i>
              </button>
            </div>

          </div>
          <div class="canvas-data">
            <div class="tab-content pt-2" id="nav-tabContent">
              <div class="tab-pane fade show active" id="nav-home" role="tabpanel">
                <ag-grid-angular style="height: calc(100vh - 160px) !important;" class="ag-theme-material"
                  (gridReady)="onGridReady($event)" [rowData]="rowData" [columnDefs]="columnDefs" pagination="true"
                  [defaultColDef]="defaultColDef" [suppressRowClickSelection]="true" [rowSelection]="rowSelection"
                  (selectionChanged)="onSelectionChanged($event)" paginationPageSize=10>
                </ag-grid-angular>
              </div>
              <div class="tab-pane fade" id="nav-profile" role="tabpanel">
                <section class="canvas-container">
                  <section class="dashboard-items">
                    <div class="canvas-item">
                      <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                          <h3>Risk Management Graphs </h3>
                        </div>
                      </div>
                      <div class="canvas-data">
                        <div class="canvas-table">

                          <div class="row">
                            <div class="col">
                              <table class="table table-bordered table-responsive" id="rMatrix">
                                <thead>
                                  <tr>
                                    <th colspan="8">Probability</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr lh="5">
                                    <!-- <td rowspan="5" class="r-header" style="text-align:center;border:none;transform: rotate(-90deg);"> -->
                                    <td rowspan="5" class="r-header">Severity</td>
                                    <td></td>
                                    <td class="M1">Very Probable</td>
                                    <td class="M1">Probable</td>
                                    <td class="M1">Perhaps</td>
                                    <td class="M1">Improbable</td>
                                  </tr>

                                  <tr lh="4">
                                    <td class="M1">Low</td>
                                    <td class="M">{{riskManagement[0][0]}}</td>
                                    <td class="M">{{riskManagement[0][1]}}</td>
                                    <td class="L">{{riskManagement[0][2]}}</td>
                                    <td class="L">{{riskManagement[0][3]}}</td>
                                  </tr>

                                  <tr lh="3">
                                    <td class="M1">Moderate</td>
                                    <td class="M">{{riskManagement[1][0]}}</td>
                                    <td class="M">{{riskManagement[1][1]}}</td>
                                    <td class="M">{{riskManagement[1][2]}}</td>
                                    <td class="L">{{riskManagement[1][3]}}</td>
                                  </tr>

                                  <tr lh="2">
                                    <td class="M1">High</td>
                                    <td class="H">{{riskManagement[2][0]}}</td>
                                    <td class="M">{{riskManagement[2][1]}}</td>
                                    <td class="M">{{riskManagement[2][2]}}</td>
                                    <td class="M">{{riskManagement[2][3]}}</td>
                                  </tr>

                                  <tr lh="1">
                                    <td class="M1">Catastropic</td>
                                    <td class="VH">{{riskManagement[3][0]}}</td>
                                    <td class="H">{{riskManagement[3][1]}}</td>
                                    <td class="M">{{riskManagement[3][2]}}</td>
                                    <td class="M">{{riskManagement[3][3]}}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <br /><br />
                              <table style="border: 1px solid #000;">
                                <tr>
                                  <td style="text-align:center;padding:5px;"><b>Legend</b></td>
                                  <td style="width:100px;height:25px;text-align:center;padding:5px;font-size: smaller;"
                                    class="L">Acceptable</td>
                                  <td style="width:100px;height:25px;text-align:center;padding:5px;font-size: smaller;"
                                    class="M">Considerable</td>
                                  <td style="width:100px;height:25px;text-align:center;padding:5px;font-size: smaller;"
                                    class="H">Dangerous</td>
                                  <td style="width:100px;height:25px;text-align:center;padding:5px;font-size: smaller;"
                                    class="VH">Very Dangerous</td>
                                </tr>
                              </table>
                            </div>

                            <div class="col">
                              <ejs-circulargauge id="circular-container" [legendSettings]='legendSettings'>
                                <e-axes>
                                  <e-axis minimum=0 maximum=100 startAngle=210 endAngle=150 [majorTicks]="majorTicks"
                                    [minorTicks]="minorTicks" [lineStyle]="lineStyle">
                                    <e-ranges>
                                      <e-range start=0 end={{lowPercentage}} radius='108%' color='#30B32D'
                                        legendText='Acceptable'></e-range>
                                      <e-range start={{lowPercentage}} end={{moderatePercentage}} radius='108%'
                                        color='#FFDD00' legendText='Considerable'></e-range>
                                      <e-range start={{moderatePercentage}} end={{highPercentage}} radius='108%'
                                        color='#F03E3E' legendText='Dangerous'></e-range>
                                      <e-range start={{highPercentage}} end=100 radius='108%' color='#f0973e'
                                        legendText='Very Dangerous'></e-range>
                                    </e-ranges>
                                    <e-pointers>
                                      <e-pointer value={{this.pointer}} radius='60%' color='#757575' pointer Width=25
                                        [needleTail]='tail' [cap]="pointerCap">
                                      </e-pointer>
                                    </e-pointers>
                                  </e-axis>
                                </e-axes>
                              </ejs-circulargauge>
                              <!--<ejs-circulargauge style='display:block;' id='circular-container' #range='' [legendSettings]='legendSettings'>
                                <e-axes>
                                  <e-axis minimum=0 maximum=120 startAngle=210 endAngle=150 [majorTicks]='majorTicks' [lineStyle]='lineStyle' [minorTicks]='minorTicks'>
                                    <e-ranges>
                                      <e-range start=0 end=40 radius='108%' color='#30B32D' legendText='acceptable'></e-range>
                                      <e-range start=40 end=80 radius='108%' color='#FFDD00' legendText='considerable'></e-range>
                                      <e-range start=80 end=120 radius='108%' color='#F03E3E' legendText='dangerous'></e-range>
                                    </e-ranges>
                                    <e-pointers>
                                      <e-pointer value=65 radius='60%' color='#757575' pointer Width=25 [needleTail]='tail' [cap]="pointerCap">
                                      </e-pointer>
                                    </e-pointers>
                                  </e-axis>
                                </e-axes>
                              </ejs-circulargauge>-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>

    <br />
    <br />

  </article>
</main>

<!-- Create Risk Management -->
<div class="modal fade bd-example-modal-lg" id="riskModel" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content pl-5 pr-5">
      <form [formGroup]="riskForm">
        <div class="modal-header">
          <h5 class="modal-title">Create Risk</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">

          <div class="container">
            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <input formControlName="evaluation" type="text">
                    <label class="floating-label">Evaluation</label>
                    <i class="ri-shield-user-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <input list="projectList" formControlName="projectId"/>
                    <datalist id="projectList">
                      <option [value]="item" *ngFor="let item of projectDropdownList"></option>
                    </datalist>
                    <label class="floating-label">Project</label>
                    <i class="ri-shield-user-line"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <select formControlName="status">
                      <!-- <option value="" disabled selected>Select Status </option> -->
                      <option value="Save">Save</option>
                      <option value="Submit">Submit</option>
                      <option value="Withdraw">Withdraw</option>
                    </select>
                    <label class="floating-label floating-label-special">Status</label>
                    <i class="ri-logout-box-r-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <input formControlName="dateFound" type="date">
                    <label class="floating-label">Date Found</label>
                    <i class="ri-building-line"></i>
                  </div>
                  <mat-error *ngIf="f.dateFound.invalid && (f.dateFound.dirty ||f.dateFound.touched)"
                    class="alert alert-danger">
                    <mat-error *ngIf="f.dateFound.errors.required">
                      dateFound is required
                    </mat-error>
                  </mat-error>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <input formControlName="dateChecked" type="date">
                    <label class="floating-label">Date Checked</label>
                    <i class="ri-building-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <input formControlName="dueDate" type="date">
                    <label class="floating-label">Due Date</label>
                    <i class="ri-building-line"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <select formControlName="highestImpactOn" class="form-select">
                      <option *ngFor="let optionName of this.highestImpactOn" value="{{optionName['optionValue']}}">
                        {{optionName['optionValue']}}</option>
                    </select>
                    <label for="description" class="floating-label floating-label-special"> Select Highest Impact
                      On</label>
                    <i class="ri-shield-user-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <select id="impactOnCustomerSatisfaction" formControlName="impactOnCustomerSatisfaction"
                      class="form-select">
                      <option *ngFor="let optionName of this.impactOnCustomer" value="{{optionName['optionValue']}}">
                        {{optionName['optionValue']}}</option>
                    </select>
                    <label for="startDate" class="floating-label floating-label-special">Select Impact On
                      Customer</label>
                    <i class="ri-shield-user-line"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <select id="riskCategory" formControlName="riskCategory" class="form-select">
                      <option *ngFor="let optionName of this.riskCategory" value="{{optionName['optionValue']}}">
                        {{optionName['optionValue']}}</option>
                    </select>
                    <label for="endDate" class="floating-label floating-label-special">Select Risk Category</label>
                    <i class="ri-shield-user-line"></i>
                  </div>
                  <mat-error *ngIf="f.riskCategory.invalid && (f.riskCategory.dirty ||f.riskCategory.touched)"
                    class="alert alert-danger">
                    <mat-error *ngIf="f.riskCategory.errors.required">
                      riskCategory is required
                    </mat-error>
                  </mat-error>
                </div>
              </div>
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <select id="strategy" formControlName="strategy" class="form-select">
                      <option *ngFor="let optionName of this.strategy" value="{{optionName['optionValue']}}">
                        {{optionName['optionValue']}}</option>
                    </select>
                    <label class="floating-label floating-label-special">Select Strategy</label>
                    <i class="ri-shield-user-line"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <select id="severity" formControlName="severity" class="form-select">
                      <option *ngFor="let optionName of this.severity" value="{{optionName['optionValue']}}">
                        {{optionName['optionValue']}}</option>
                    </select>
                    <label class="floating-label floating-label-special">Select Severity</label>
                    <i class="ri-shield-user-line"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <!--<input formControlName="probalility" type="text" required>-->
                    <select id="probability" formControlName="probability" class="form-select">
                      <option *ngFor="let optionName of this.probability" value="{{optionName['optionValue']}}">
                        {{optionName['optionValue']}}</option>
                    </select>
                    <label class="floating-label floating-label-special">Select Probability</label>
                    <i class="ri-shield-user-line"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <div class="input">
                  <div class="input-item">
                    <input formControlName="additionalCost" type="text">
                    <label for="status" class="floating-label">Additional Cost</label>
                    <i class="ri-shield-user-line"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="input">
                  <div class="input-item">
                    <textarea formControlName="description" type="text" rows="3" cols="100"></textarea>
                    <label class="floating-label">Description</label>
                    <!--<i class="ri-shield-user-line"></i>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalRiskManagement" class="btn btn-secondary"
            data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createRiskManagements()"
            [disabled]="!riskForm.valid">Create</button>
          <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateRiskManagements()"
            [disabled]="!riskForm.valid">Update</button>
        </div>
    </form>
  </div>
</div>
</div>

<!-- Delete an item -->
<div class="modal fade" id="deleteRiskModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content pl-5 pr-5">
      <form action="">
        <div class="modal-header">
          <h5 class="modal-title">Are you sure want to delete?</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="text-center">
            <p>{{deleteConfirmationMsg}}?</p>
          </div>
        </div>
        <div class="modal-footer">
          <button id="closeModalDeleteRiskManagement" type="button" class="btn btn-secondary"
            data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0"
            (click)="deleteRiskManagements()">Yes Delete</button>
        </div>
      </form>
    </div>
  </div>
</div>

<style>
  .r-header {
    writing-mode: vertical-rl;
    /* vertical text */
    transform: rotate(180deg);
    /* correct reading direction */
    text-align: center;
    font-weight: bold;
    background-color: #f5f5f5;
    width: 50px;
    border: 1px solid #000;
  }

  td {
    border: 1px solid #000;
    border-collapse: collapse;
  }

  .VH {
    /* background-color: #f90909; */
    background-color: #8b0000;
    color: #fff;
    font-weight: 550 !important;
  }

  .H {
    /* background-color: green; */
    background-color: #F44336;
    color: #fff;
    font-weight: 550 !important;
  }

  .M {
    /* background-color: #f9d909; */
    height: 60px;
    background-color: #FFC107;
    color: #fff;
    /* color: #000; */
    font-weight: 550 !important;
  }

  .L {
    /* background-color: red; */
    background-color: #4CAF50;
    color: #fff;
    font-weight: 550 !important;
  }

  #rMatrix {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #000;
    /* Adds border on all sides */
  }

  #rMatrix td,
  #rMatrix th {
    border: 1px solid #000;
    text-align: center;
    vertical-align: middle;
    font-weight: 550;
  }

  /* Headers */
  .M1 {
    height: 60px;
    padding: 10px;
    background-color: #f1f1f1;
    font-weight: bold;
  }
</style>